import React, { memo } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerComponent = ({
  selectedDate,
  onChange,
  dateFormat = "dd/MM/yyyy",
  placeholderText = "Select a date",
  isClearable = true,
  minDate = null,
  maxDate = null,
  disabled = false,
  showTimeSelect = false,
  timeFormat = "HH:mm",
  timeIntervals = 15,
  className = "",
  wrapperClassName = "",
  ...props
}) => {
  return (
    <div className={`date-picker-wrapper ${wrapperClassName}`}>
      <DatePicker
        selected={selectedDate}
        onChange={onChange}
        dateFormat={showTimeSelect ? `${dateFormat} ${timeFormat}` : dateFormat}
        placeholderText={placeholderText}
        isClearable={isClearable}
        minDate={minDate}
        maxDate={maxDate}
        disabled={disabled}
        showTimeSelect={showTimeSelect}
        timeFormat={timeFormat}
        timeIntervals={timeIntervals}
        className={`form-control ${className}`}
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        autoComplete="off"
        {...props}
      />
    </div>
  );
};

export default memo(DatePickerComponent);
